import { putSurveyAnswer } from "@/API/bookGroup/putSurveyAnswer";

/**
 * アンケートの回答を送信する
 * @param {number} bookGroupId
 * @param {Array} questions - 質問オブジェクトの配列
 * @param {Object} answers - 質問IDをキーとする回答オブジェクト
 * @returns {Promise<void>}
 */
export const submitSurveyAnswers = async (bookGroupId, questions, answers) => {
  if (!questions || !answers) {
    throw new Error("submitSurveyAnswers: questions/answersが不正です");
  }
  const answerList = questions.map((question) => ({
    id: question.id,
    question: question.question,
    value: answers[question.id],
  }));
  await putSurveyAnswer(bookGroupId, answerList);
};
